import api from '@Services/api';
import { AxiosResponse } from 'axios';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';
import { AttendancesPayload } from '../Types/Attendaces.types';

interface AttendancesCRUD
	extends CRUDBase<AttendancesPayload, AttendancesPayload> {}
export class AttendancesRequester implements AttendancesCRUD {
	get(id: string): Promise<AxiosResponse<ApiResponse<AttendancesPayload>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<AttendancesPayload>>>;
	get(
		id: string | number,
		tId?: string | number | undefined,
		payload?: GetSingleEntityPayload | undefined
	): Promise<AxiosResponse<ApiResponse<AttendancesPayload>>>;
	get(
		id: unknown,
		tId?: unknown,
		payload?: unknown
	): Promise<AxiosResponse<ApiResponse<AttendancesPayload>>> {
		throw new Error('Method not implemented.');
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload?: DeleteSingleEntityPayload | undefined
	): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: unknown,
		payload?: unknown
	): Promise<AxiosResponse<ApiResponse<any>>> {
		throw new Error('Method not implemented.');
	}
	create(
		payload: Omit<AttendancesPayload, 'id'>
	): Promise<AxiosResponse<ApiResponse<AttendancesPayload>>> {
		throw new Error('Method not implemented.');
	}
	update(
		payload: AttendancesPayload
	): Promise<AxiosResponse<ApiResponse<AttendancesPayload>>> {
		throw new Error('Method not implemented.');
	}
	private static instance: AttendancesRequester;
	static getInstance() {
		if (!AttendancesRequester.instance) {
			AttendancesRequester.instance = new AttendancesRequester();
		}
		return AttendancesRequester.instance;
	}
	baseURL = 'classroom/analytics/attendance';
	async export(payload: GetAllMeta): Promise<AxiosResponse<string>> {
		return await api.post(`${this.baseURL}`, { ...payload, export: true });
	}
	getAll(
		payload?: GetAllMeta
	): Promise<AxiosResponse<ApiResponse<AttendancesPayload[]>>>;
	getAll(
		payload: number
	): Promise<AxiosResponse<ApiResponse<AttendancesPayload[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<AttendancesPayload[]>>> {
		return await api.post(`${this.baseURL}`, payload);
	}
}
